

// Get items to show in the current page
export function getCurrentPageItems(items, currentPageNumber, numberOfItemsPerPage) {
    const startIndex = (currentPageNumber - 1) * numberOfItemsPerPage;
    return items.slice(startIndex, startIndex + numberOfItemsPerPage);
}
